// Central config for the omni-score landing page
export const SUPPORT_URL =
  "https://app.emergent.sh/showcase/fabrizio/08933f64-c720-4a27-9f93-243d3a55fa6d?utm_source=share";

// Current like count shown in the CTA hint chip. Update this one value
// to match the live count on the showcase page.
export const LIKE_COUNT = 6;

export const COPY = {
  nav_cta: { en: "Support", it: "Sostieni" },
};
